<template>
  <div class="CourseDisease">
    <div class="content">
      <LeftList
        @refresh="refresh"
        class="left"
        :class="{ 'empty-content': !diagnosisPattern.ucDoctorId }"
      ></LeftList>
      <!-- 线下处方 -->
      <DetailOffLine v-if="diagnosisPattern.type === 3" class="right" />
      <!-- 线上处方 -->
      <DetailUnite v-else-if="[0, 1, 2].includes(diagnosisPattern.type)" class="right" />
      <EmptyText v-else class="right empty-content" />
    </div>
    <div class="Scale">
      <h1 class="title">量表</h1>
      <a-table
        :bordered="true"
        :pagination="pagination"
        :row-key="(_, index) => index"
        :scroll="{ x: 100, y: 280 }"
        :dataSource="dataScale"
        :columns="colScale"
        @change="change"
      >
        <template #sendName="{ record }">
          <div v-if="record.surveyShape === 1">--</div>
          <div v-else>
            <!-- 发送人 -->
            <roles :solerType="record.sendPersonType" />
            {{ record.sendPersonName }}
          </div>
        </template>
        <template #operation="{ record }">
          <a @click="openDetail(record)">查看详情</a>
        </template>
      </a-table>
      <!-- 问卷结果iframe -->
      <Info ref="infoRef" :url="scaleResultsUrl"></Info>
      <Gauge ref="gDetail" :params="detailQuery" />
      <ImageList
        :visible="imgObj.imgVisible"
        title="量表"
        :tips="imgObj.tips"
        :fileList="imgObj.fileList"
        @cancel="handleCancel"
      />
    </div>
  </div>
</template>

<script setup>
import { colScale } from '@/components/PatientFile/config'
import LeftList from './LeftList.vue'
import DetailUnite from './DetailUnite.vue'
import DetailOffLine from './DetailOffLine.vue'
import { computed, reactive, ref, watch } from 'vue'
import { gaugeList } from '@/api/workPlace/gauge.js'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import Info from '@/views/WorkPlace/Container/chat/components/ScaleResults/Info.vue'
import ImageList from '@/components/ImageList'
import Gauge from '@/views/WorkPlace/Container/Gauge/components/gDetail.vue'
import EmptyText from '@/components/PatientFile/EmptyText.vue'
import { defineEmits } from 'vue'
const store = useStore()
// 量表数据
const dataScale = ref([])
const scaleResultsUrl = ref('')
const infoRef = ref('')
const ucPatientId = computed(() => store.state.patientFile.info.ucPatientId)
const diagnosisPattern = computed(() => store.state.patientFile.diagnosisPattern)
const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})
// 查看量表详情
const gDetail = ref(null)
const detailQuery = reactive({
  surveyId: null,
  surveySendId: null
})
const imgObj = reactive({
  imgVisible: false,
  fileList: [],
  tips: ''
})
// 量表数据
const getList = async () => {
  dataScale.value = []
  // 必须要
  if (!ucPatientId.value) return
  const params = {
    current: pagination.value.current,
    size: pagination.value.pageSize,
    surveyShape: 0,
    patientId: ucPatientId.value
  }
  const { list, totalCount } = await gaugeList(params)
  pagination.value.total = totalCount
  pagination.value.showTotal = () => `共${totalCount}条`
  dataScale.value = list
}
const openDetail = row => {
  if (row.surveyShape) {
    imageDetail(row)
  } else {
    rowDetail(row)
  }
}
const rowDetail = record => {
  console.log(record)
  const { surveyId, id, surveyType, url } = record
  if (surveyType !== 1) {
    if (!url) return message.warning('当前量表暂不支持查看！')
    scaleResultsUrl.value = `${url}&mood=readPretty&surveyType=${surveyType}`
    return infoRef.value.showDrawer()
  }
  gDetail.value.gDetailVisible = true
  detailQuery.surveyId = surveyId
  detailQuery.surveySendId = id
}
const imageDetail = record => {
  console.log(record)
  const { pictureFileList, writingAt } = record
  imgObj.imgVisible = true
  imgObj.fileList = pictureFileList
  imgObj.tips = `上传时间:${writingAt}`
}
// 关闭弹窗
const handleCancel = () => {
  imgObj.imgVisible = false
  imgObj.fileList = []
  imgObj.tips = ''
}
const change = page => {
  pagination.value.current = page?.current || 1
  pagination.value.pageSize = page?.pageSize || 10
  getList()
}
const emits = defineEmits('refresh')
const refresh = () => {
  emits('refresh')
}
watch(
  () => ucPatientId.value,
  () => {
    change()
  },
  {
    immediate: true
  }
)
</script>

<style lang="scss" scoped>
.CourseDisease {
  .content {
    border-radius: 4px;
    display: flex;
    background-color: white;
    .left {
      flex-shrink: 0;
      height: 780px;
      width: 325px;
    }
    .right {
      flex-grow: 1;
      height: 780px;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 12px 4px 12px 16px;
    }
    .empty-content {
      height: auto;
    }
  }
  .Scale {
    background-color: white;
    border-radius: 4px;
    margin-top: 12px;
    padding: 16px;
    .title {
      font-weight: 400;
      font-size: 16px;
      color: #1c1c1c;
    }
  }
}
</style>
